module.exports = __webpack_public_path__ + "img/logo_small.4c737250.svg";